import React from 'react';

const MyReview = () => {
    return (
        <div>
            <h2>This is my review</h2>
        </div>
    );
};

export default MyReview;